import React from 'react';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';

interface Props {
  children: React.ReactNode;
  type?: 'primary' | 'secondary';
}

export const TagTitle: React.FC<Props> = ({
  children,
  type = 'primary',
}) => (
  <div className={constructClassName([
    styles.container,
    type === 'secondary' && styles.secondary,
    type === 'primary' && styles.primary,
  ])}
  >
    <h3 className={styles.title}>{children}</h3>
    <span className={styles.circle} />
  </div>
);
